import Login from '../containers/LoginContainer';
import HotelList from '../containers/HotelListContainer';
import HotelDetail from '../containers/HotelDetailContainer';
// import BuildingList from '../containers/BuildingListContainer';
// import BuildingDetail from '../containers/BuildingDetailContainer';
// import FloorList from '../containers/FloorListContainer';
// import FloorDetail from '../containers/FloorDetailContainer';
// import RoomList from '../containers/RoomListContainer';
// import RoomDetail from '../containers/RoomDetailContainer';
import DoorlockList from '../containers/DoorlockListContainer';
import DoorlockDetail from '../containers/DoorlockDetailContainer';
import DoorlockTileList from '../containers/DoorlockTileListContainer';
import BookingList from '../containers/BookingListContainer';
import BookingDetail from '../containers/BookingDetailContainer';
import StaffList from '../containers/StaffListContainer';
import StaffDetail from '../containers/StaffDetailContainer';
import ReportList from '../containers/ReportListContainer';

const mainRoutes = {
  path: '/',
  name: 'Main',
  component: Login,
  children: null
};

const loginRoutes = {
  path: '/login',
  name: 'Login Page',
  component: Login,
  children: null
};

const hotelRoutes = {
  path: '/home',
  name: 'Hotel List Page',
  component: HotelList,
  children: null,
};

const hotelDetailRoutes = {
  path: '/hotel/:id',
  name: 'Hotel Detail Page',
  component: HotelDetail,
  children: null,
};

// const buildingRoutes = {
//   path: '/building',
//   name: 'Building List Page',
//   component: BuildingList,
//   children: null,
// };

// const buildingDetailRoutes = {
//   path: '/building/:id',
//   name: 'Building Detail Page',
//   component: BuildingDetail,
//   children: null,
// };

// const floorRoutes = {
//   path: '/floor',
//   name: 'Floor List Page',
//   component: FloorList,
//   children: null,
// };

// const floorDetailRoutes = {
//   path: '/floor/:id',
//   name: 'Floor Detail Page',
//   component: FloorDetail,
//   children: null,
// };

// const roomRoutes = {
//   path: '/room',
//   name: 'Room List Page',
//   component: RoomList,
//   children: null,
// };

// const roomDetailRoutes = {
//   path: '/room/:id',
//   name: 'Room Detail Page',
//   component: RoomDetail,
//   children: null,
// };

const doorlockRoutes = {
  path: '/doorlock',
  name: 'Door lock List Page',
  component: DoorlockList,
  children: null,
};

const doorlockDetailRoutes = {
  path: '/doorlock/:id',
  name: 'Door lock Detail Page',
  component: DoorlockDetail,
  children: null,
};

const doorlockTileRoutes = {
  path: '/doorlockTile',
  name: 'Door lock List Page (tile type)',
  component: DoorlockTileList,
  children: null,
};

const doorlockTileDetailRoutes = {
  path: '/doorlockTile/:id',
  name: 'Door lock Detail Page (tile type)',
  component: DoorlockDetail,
  children: null,
};

const bookingRoutes = {
  path: '/booking',
  name: 'Booking List Page',
  component: BookingList,
  children: null
};

const bookingDetailRoutes = {
  path: '/booking/:id',
  name: 'Booking Detail Page',
  component: BookingDetail,
  children: null
};

const staffRoutes = {
  path: '/staff',
  name: 'Staff List Page',
  component: StaffList,
  children: null
};

const staffDetailRoutes = {
  path: '/staff/:id',
  name: 'Staff Detail Page',
  component: StaffDetail,
  children: null
};

const reportRoutes = {
  path: '/report',
  name: 'Report List Page',
  component: ReportList,
  children: null
};

export const routesList = [
  mainRoutes,
  loginRoutes,
  hotelRoutes,
  hotelDetailRoutes,
  // buildingRoutes,
  // buildingDetailRoutes,
  // floorRoutes,
  // floorDetailRoutes,
  // roomRoutes,
  // roomDetailRoutes,
  doorlockRoutes,
  doorlockDetailRoutes,
  doorlockTileRoutes,
  doorlockTileDetailRoutes,
  bookingRoutes,
  bookingDetailRoutes,
  staffRoutes,
  staffDetailRoutes,
  reportRoutes,
];